/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { SrTopic } from '@src/app/model/sr-topic';

/** Service request topics - server reference data from `crm/requests/topics`. Fetched fresh each call. */
@Injectable({
    providedIn: 'root'
})
export class SrTopicService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);

    protected get baseUrl() {
        return this.getAjaxPath('crm/requests/topics');
    }

    protected cache: SrTopic[] = [];
    protected typeString = 'Request Topic';
    protected hasRevision = false;
}
